export class Transaction{
    _id?: string;
    type?: string;
    ref?: string;
    year?: string;
    number?: number;
    createdAt?: Date;
    updatedAt?: Date;
    executed?: boolean;
    toCompany?: object;
    toProject?: object;
    toAddress?: object;
    toAddressInvoicing?: object;
    fromAddress?: object;
    contents?: Contents;
    sale?: boolean;
  }

  class Contents {
    unique?: UniqueContents[];
    bulk?: BulkContents[];
  }

  class UniqueContents {
    sku?: string;
    quantity?: number;
    refs?: string[];
    metadata?: object;
  }

  class BulkContents {
    sku?: string;
    quantity?: number;
    metadata?: object;
  }